(function () {
	"use strict";

	const CARD_SELECTOR = "[data-productgrid-items] [data-product-item]";
	const COUNTRY_SEPARATOR = "||";

	function normalizeCountry(value) {
		const country = typeof value === "string" ? value.trim().toLowerCase() : "";
		return country === "south korea" ? "korea" : country;
	}

	function parseCountries(raw) {
		if (typeof raw === "undefined" || raw === "") return [];
		if (typeof raw !== "string") return null;
		const values = raw.split(COUNTRY_SEPARATOR).map(normalizeCountry);
		return values.every(Boolean) ? [...new Set(values)] : null;
	}

	function isProductEligible(vehicleCountry, compatibleRaw, incompatibleRaw) {
		const country = normalizeCountry(vehicleCountry);
		if (!country) return true;

		const compatible = parseCountries(compatibleRaw);
		const incompatible = parseCountries(incompatibleRaw);
		if (!compatible || !incompatible) return true;

		if (incompatible.includes(country)) return false;
		return !compatible.length || compatible.includes(country);
	}

	function getSelectedVehicleCountry() {
		try {
			const vehicles =
				typeof window.getSearchTerms === "function"
					? window.getSearchTerms()
					: JSON.parse(localStorage.getItem("searchTerms") || "[]");
			const vehicle = Array.isArray(vehicles) ? vehicles[0] : null;
			const vin = String((vehicle && vehicle.vin) || "")
				.trim()
				.toUpperCase();
			if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) return "";
			return vehicle && typeof vehicle.wmiCountry === "string"
				? vehicle.wmiCountry
				: "";
		} catch (error) {
			return "";
		}
	}

	function apply(root = document) {
		if (!/\/collections\/\d{4}-/i.test(window.location.pathname)) return;
		const vehicleCountry = getSelectedVehicleCountry();
		root.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
			const eligible = isProductEligible(
				vehicleCountry,
				card.dataset.vinCountryCompatible,
				card.dataset.vinCountryIncompatible,
			);
			card.toggleAttribute("data-vin-country-hidden", !eligible);
		});
	}

	window.PartifyCollectionCountryFilter = {
		isProductEligible,
	};

	apply();
	window.addEventListener("searchTermsUpdated", function () {
		apply();
	});
	window.addEventListener("partify:vehicle:changed", function () {
		apply();
	});
	document.addEventListener("shopify:section:load", function (event) {
		apply(event.target);
	});
})();
